import React, { useState } from "react";
import '../../../assets/InnerCSS/css/rating.css';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { IAIEnum } from "../../../models/enums/IAIEnum";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import InterviewRatingModel from "../../../models/interviewer/response/InterviewRatingModel";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import { toJpeg } from "html-to-image";

interface RatingDetailsProps {
    objRatingDetails: InterviewRatingModel;
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const RatingDetailsComponent = (props: RatingDetailsProps) => {

    async function downloadRatingPdf() {
        const input = document.getElementById("rating-div") as HTMLElement;
        if (!input) return;

        const buttons = input.querySelectorAll(".model-header-buttons") as NodeListOf<HTMLElement>;
        buttons.forEach(b => (b.style.display = "none"));

        const scrollables = Array.from(
            input.querySelectorAll(".rating-content-mh")
        ) as HTMLElement[];

        const originalHeights = scrollables.map(el => el.style.maxHeight);
        scrollables.forEach(el => {
            el.style.maxHeight = "none";
            el.style.overflow = "visible";
        });

        const originalWidth = input.style.width;
        input.style.width = `${input.offsetWidth}px`;

        try {
            const canvas = await html2canvas(input, {
                scale: 1.25,
                backgroundColor: "#FFFFFF",
                useCORS: false,
                removeContainer: true,
                logging: false
            });

            const pdf = new jsPDF({
                orientation: "p",
                unit: "pt",
                format: "a4",
                compress: true
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pageWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            const imgData = canvas.toDataURL("image/jpeg", 0.85);

            while (heightLeft > 0) {
                pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
                position -= pageHeight;

                if (heightLeft > 0) pdf.addPage();
            }

            pdf.save(`${props.objRatingDetails.candidateName}.pdf`);
        } finally {
            buttons.forEach(b => (b.style.display = ""));
            input.style.width = originalWidth;
            scrollables.forEach((el, i) => {
                el.style.maxHeight = originalHeights[i];
                el.style.overflow = "auto";
            });
        }
    };


    const downloadImage = async () => {
        const source = document.getElementById("rating-div") as HTMLElement;
        if (!source) return;

        const buttons = source.querySelectorAll(".model-header-buttons") as NodeListOf<HTMLElement>;
        buttons.forEach(btn => (btn.style.display = "none"));

        try {
            const dataUrl = await toJpeg(source, {
                quality: 0.85,
                pixelRatio: 1.25,
                backgroundColor: "#FFFFFF"
            });

            const link = document.createElement("a");
            link.download = `${props.objRatingDetails.candidateName}.jpg`;
            link.href = dataUrl;
            link.click();
        } finally {
            buttons.forEach(btn => (btn.style.display = ""));
        }
    };

    return (
        <div className="row" id="rating-div">
            <div className="rating-banner">
                <div className="row top-row-modal">
                    <div className="col-md-6">
                        {props.objRatingDetails.companyLogo &&
                            <img className="rating-logo-company" src={`data:image/png;base64,${props.objRatingDetails.companyLogo}`} alt="Company Logo" />
                        }
                    </div>
                    <div className="col-md-6 act-icon d-flex justify-content-end">
                        <a className="model-header-buttons" title="Download Rating as Pdf" id="btnGeneratePdf" onClick={() => downloadRatingPdf()}><i className="fa-solid fa-file-pdf"></i></a>
                        <a className="model-header-buttons" title="Download Rating as Image" id="btnImageDownload" onClick={() => downloadImage()}><i className="fa-regular fa-file-image"></i></a>
                    </div>
                </div>
                <div className="row center-align-container">
                    <div className="col-lg-5 col-md-5">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 center-align-container mobile-display-none">
                                <div className="user-name-wrapper">
                                    <div className="name-letter">
                                        {props.objRatingDetails.candidateName
                                            ? props.objRatingDetails.candidateName.charAt(0).toUpperCase()
                                            : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8 user-details-banner">
                                <h1>{props.objRatingDetails.candidateName}</h1>
                                <h2>{props.objRatingDetails.designationName}</h2>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <p><i className="fas fa-phone-alt"></i> {props.objRatingDetails.mobileNo}</p>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <p><i className="far fa-envelope"></i> {props.objRatingDetails.emailId}</p>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <p><i className="fas fa-map-marker-alt"></i> {props.objRatingDetails.cityName}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2 bl-1">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 text-center ">
                                <CircularProgressbar
                                    value={(Number(props.objRatingDetails.totalRating) / IAIEnum.MaxRating) * 100}
                                    text={`${(
                                        (Number(props.objRatingDetails.totalRating) / IAIEnum.MaxRating) * 100
                                    ).toFixed(0)}%`}
                                    strokeWidth={7}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-5 user-details-banner right-user-details">
                        <div className="col-lg-12 col-md-12">
                            <p><i className="fas fa-video"></i> Recording <a href={props.objRatingDetails.interviewRecordingTitle} target="_blank" className="play-video"><i className="fas fa-play"></i></a> ({props.objRatingDetails.passcode})</p>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <p><i className="fas fa-flag-checkered"></i> Is Genuine : <span><b>{props.objRatingDetails.isGenuine === null ? "N/A" : props.objRatingDetails.isGenuine === true ? "Yes" : "No"}</b></span></p>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <p><i className="far fa-hand-point-right"></i> Recommend For Next Round : <span><b>{props.objRatingDetails.recommendForNextRound === null ? "No" : props.objRatingDetails.recommendForNextRound === true ? "Yes" : "No"}</b></span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cols-lg-12 col-md-12">
                <div className="skil-rating-container">
                    <div className="row">
                        <div className="cols-lg-12 col-md-12">
                            <div className="card card-white ">
                                <div className="card-head">Quick Recap of Interview</div>
                                <div className="card-body ">
                                    <p className="rating-block-comments">
                                        {props.objRatingDetails?.interviewRecordingSummary?.quickRecap}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card-white">
                                <div className="card-head">
                                    Technical Rating
                                    <span className="skills-rating">({props.objRatingDetails.totalRating} / {IAIEnum.MaxRating})</span>
                                </div>
                                <div className="card-body rating-content-mh">
                                    {props.objRatingDetails.technicalSkillRating.map((rating, index) => (
                                        <div key={index} className={"row rating-block-skill-row"}>
                                            <div className="col-md-12">
                                                <span className="rating-block-skill-name">{rating.secondarySkillName}</span>: <span className="rating-block-rating">{rating.rating}</span>
                                            </div>
                                            <div className="col-md-12">
                                                <span className="skill-block-comments">{rating.comments}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card card-white">
                                <div className="card-head">
                                    Soft Skill Rating
                                </div>
                                <div className="card-body rating-content-mh">
                                    {props.objRatingDetails.softSkillRating.map((rating, index) => (
                                        <div className="row rating-block-skill-row"
                                            key={index}>
                                            <div className="col-md-12">
                                                <span className="rating-block-skill-name">{rating.softSkillName}</span>
                                                : <span className="rating-block-rating">{rating.rating}</span>
                                            </div>
                                            <div className="col-md-12">
                                                <span className="rating-block-comments">{rating.comments}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="cols-lg-12 col-md-12">
                            <div className="card card-white ">
                                <div className="card-head"> Summary of the Discussion</div>
                                <div className="card-body">
                                    {props.objRatingDetails?.interviewRecordingSummary?.interviewRecordingSummaryDetails?.map((item, index) => (
                                        <div className="rating-block-comments">
                                            <h6>{item.title}</h6>
                                            <p>
                                                {item.description}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="cols-lg-12 col-md-12">
                            <div className="card card-white ">
                                <div className="card-head"> Interviewer Comments</div>
                                <div className="card-body ">
                                    <p className="rating-block-comments">{props.objRatingDetails.interviewerComments}</p>
                                </div>
                            </div>
                            <p className="iai-link-footer"><a href="https://iaminterviewed.com/" target="_blank">www.iaminterviewed.com</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default RatingDetailsComponent;